import date from "./date"

export default {
  namespaced: true,
  modules: {
    date
  }
}
